const api = "https://www.srivishaliartbangles.com/admin/api/";

export { api };
